module.exports = __webpack_public_path__ + "img/imge2.ba50752d.png";